import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-9">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-10">
        <span className="font-display font-semibold text-lg md:text-xl text-slate-900 pr-8" data-id="element-11">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-brand-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-12" />
      </button>
      <AnimatePresence data-id="element-13">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-14">
            <p className="pb-4 text-slate-600 text-lg leading-relaxed" data-id="element-15">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Para qué edades sirve?',
    answer: 'Para chicos de 5 a 14 años. Las actividades tienen distintos niveles de dificultad, así que sirve para hermanos de diferentes edades al mismo tiempo.'
  }, {
    question: '¿Necesito comprar materiales especiales?',
    answer: 'No. El 90% de los materiales ya los tenés en casa. Cartón, tijeras, pegamento, vinagre, bicarbonato. La lista completa viene incluida en el Bonus #2.'
  }, {
    question: '¿Cómo recibo el kit?',
    answer: 'Es 100% digital. Apenas comprás, recibís un email con el acceso a todo el material. En menos de 5 minutos ya lo tenés.'
  }, {
    question: '¿Lo pueden hacer los chicos solos?',
    answer: 'Sí. Las instrucciones están diseñadas para que chicos desde 5 años puedan seguirlas. Para los más chiquitos, los primeros pasos los podés hacer juntos — eso también es parte de la diversión.'
  }, {
    question: '¿Y si no me gusta?',
    answer: 'Garantía total. Te devolvemos el dinero sin preguntas.'
  }, {
    question: '¿Sirve si tengo una sola impresora en casa?',
    answer: 'Sí. Podés ir imprimiendo las plantillas de a poco. No necesitás imprimir todo de una.'
  }];
  return <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl p-6 md:p-8" data-id="element-16">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-17" />)}
    </div>;
}